import DOMUtils from "../../ts/utils/DOMUtils";
import ManningContentUtils from "../../ts/utils/ManningContentUtils";
import { ILivebookLocation, ILivebookLogReadingLocation, ILivebookReadingLogBaseInfo } from "../provider/ILivebookViewerProvider";

class LivebookViewerHelperClass {
    public specifiedHeadingClass?: string;
    public specifiedBookmarkupClass?: string;
    
    public getCurrentReadingPosition(sessionId: any, livebookLocation: ILivebookLocation, livebookReadingLogBaseInfo: ILivebookReadingLogBaseInfo): ILivebookLogReadingLocation {
        const headings = this.getHeadings();
        const lastHeading = this.getLastHeading(headings);
        if(lastHeading == null) { return null; }
        
        let sectionNumbering = "", position = livebookLocation.location;

        if(lastHeading != null){
            sectionNumbering = ManningContentUtils.extractNumbering(lastHeading.textContent.trim());
            const currentSectionTitle = lastHeading.textContent.trim();
    
            if (currentSectionTitle) {
                let title = currentSectionTitle.trim();
                let sectionNumberingFull = ManningContentUtils.extractNumbering(title);
                if (sectionNumberingFull) {
                    let sectionNumberingParts = sectionNumberingFull.split(".");
                    sectionNumbering = sectionNumberingParts[0] + "." + (sectionNumberingParts[1] ? `${sectionNumberingParts[1]}.` : "");
                }
            }
        }
        
        return {
            ...livebookLocation,
            userOwnsBook: livebookReadingLogBaseInfo.userOwnsBook,
            isOpenChapter: livebookReadingLogBaseInfo.isOpenChapter,
            manningId: livebookReadingLogBaseInfo.manningId,
            meapVersion: livebookReadingLogBaseInfo.meapVersion,
    
            bookShortName: livebookReadingLogBaseInfo.bookShortName,
            sisterLicenseId: livebookReadingLogBaseInfo.sisterLicenseId,
            associatedLicenseId: livebookReadingLogBaseInfo.associatedLicenseId,
            location: position || livebookLocation.location,
            sessionId: sessionId,
            bookSectionNumber: sectionNumbering
        };
    }

    private getScrollContainer(){
        return DOMUtils.getScrollParent(document.querySelector(this.specifiedBookmarkupClass || ".search-root .book-markup-container.livebook-viewer-content, .livebook-viewer-product-page-root .book-markup-container.livebook-viewer-content"))
    }

    private getLastHeading(headings){
        const scrollContainer = this.getScrollContainer();

        if(scrollContainer == null) { return null; }

        const scrollTop = scrollContainer.scrollTop;

        for(let i = headings.length - 1; i >= 0; i--){
            const heading = headings[i];
            if(heading.offsetTop <= scrollTop) {
                return heading;
            }
        }

        return headings[0];
    }

    private getHeadings(){
        const titleElements = document.querySelectorAll(this.specifiedHeadingClass || ".search-root .livebook-viewer-root h1, .search-root .livebook-viewer-root h2, .search-root .livebook-viewer-root h3, .search-root .livebook-viewer-root h4, .search-root .livebook-viewer-root h5, .livebook-viewer-product-page-root .livebook-viewer-root h1, .livebook-viewer-product-page-root .livebook-viewer-root h2, .livebook-viewer-product-page-root .livebook-viewer-root h3, .livebook-viewer-product-page-root .livebook-viewer-root h4, .livebook-viewer-product-page-root .livebook-viewer-root h5");
        
        const headings = [];
        
        for(let i = 0; i < titleElements.length; i++){
            const titleElement = titleElements[i];
            const title = titleElement.textContent.trim();
            const parent = titleElement.parentElement;
            if(parent != null && parent.classList.contains("readable-text") 
            && (ManningContentUtils.isChapterOrAppendix(title) || ManningContentUtils.isSection(title) || ManningContentUtils.isSubsection(title))){
                headings.push(parent);
            }
        }

        return headings;
    }
    
    public emphasizeWords(html: string, wordsToEmphasize: string[], focusOnlyOnReadableText: boolean = true): string {
        const container = document.createElement("div");
        container.innerHTML = html;

        try {            
            const paragraphs = focusOnlyOnReadableText ? container.querySelectorAll(".readable-text") : container.querySelectorAll("p, li");
            for(let i = 0; i < paragraphs.length; i++){
                const paragraph = paragraphs[i] as HTMLElement;
                const text = paragraph.textContent.toLowerCase();
                
                for(const wordToEmphasize of wordsToEmphasize){
                    if(text.indexOf(wordToEmphasize) >= 0){
                        DOMUtils.highlightWord(paragraph, wordToEmphasize, "search-query-word", true);
                        break;
                    }
                }
            }
        }
        catch(e){
            console.log(e);
        }

        return container.innerHTML;
    }

    
    
    public extractDataFromUrl(url: string) {
        const indexOfPoint = (url || "").indexOf("/point-");
        if (indexOfPoint == -1) { return null; }

        const parts = url.substr(indexOfPoint).split("-");
        if (parts == null) { return null; }

        const pointingLinkId = parts[1];
        let meapVersion = null;
        let previusUrlPartIndex = this.getFirstPreviousIndexOf(url, "/", indexOfPoint);
        if (previusUrlPartIndex == -1) { return null; }

        let urlPart = url.substring(previusUrlPartIndex, indexOfPoint);
        if (urlPart.startsWith("/v-")) {
            const meapVersionMatch = urlPart.match(/[0-9]+/);
            if (meapVersionMatch) {
                meapVersion = meapVersionMatch[0];
            }

            let oneMorePreviewPartIndex = this.getFirstPreviousIndexOf(url, "/", previusUrlPartIndex);
            urlPart = url.substring(oneMorePreviewPartIndex, previusUrlPartIndex);
        }

        return {
            bookElementShortName: urlPart.replace("/", ""),
            meapVersion: meapVersion,
            pointingLinkId: pointingLinkId
        };
    }

    private getFirstPreviousIndexOf(haystack: string, needle: string, startIndex: number) {
        for (let i = startIndex - 1; i >= 0; i--) {
            if (haystack[i] == needle) {
                return i;
            }
        }

        return -1;
    }

    public fixHtml(html: string, livebookRootLink: string, livebookAwsLink: string, shouldRemoveNumbering: boolean) {
        const bookLinkStart = "/book/"
        const replacement = `${livebookRootLink}/${bookLinkStart}`;

        let result = (html || "").replace(/{{BOOK_ROOT_FOLDER}}/g, livebookAwsLink)
                                 .replace(/#!\/book\//g, "/book/")
                                 .replace(/\/book\//g, replacement)
                                 .replace(/([^:]\/)\/+/g, "$1");
                                 
        if (shouldRemoveNumbering) {
            //Chapter version 1
            let myRegExp = new RegExp('(<h([0-9]).*>)Chapter( |&nbsp;)+[0-9.]+( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '$1 ');
            //Chapter version 2
            myRegExp = new RegExp('(<h[0-9].*chapter.*>)[0-9.]+ ', 'gi');
            result = result.replace(myRegExp, '$1 ');

            //Lesson
            myRegExp = new RegExp('(<h([0-9]).*>)Lesson( |&nbsp;)+[0-9.]+( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '$1 ');

            //lower level
            myRegExp = new RegExp('<h([0-9]) id=\"(.*)\">(<a id=\"ch[0-9]*lev[0-9]*sec[0-9]*__title\"><\/a>)?[0-9.]+( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '<h$1 id="$2">$3');
            //lower level version 2
            myRegExp = new RegExp('(<h[0-9] .*\/a>)[0-9.]+( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '$1 ');

            //Appendix C
            myRegExp = new RegExp('<h([0-9]) id=\"(.*)\">Appendix [0-9A-Z]+.( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '<h$1 id=\"$2\">');

            //Figures in headings
            myRegExp = new RegExp('(<h[0-9]*.*?)(figure)( |&nbsp;)+[0-9.]*( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '$1');
            //Figures outside headings
            myRegExp = new RegExp('(figure)( |&nbsp;)+[0-9.]+', 'g');
            result = result.replace(myRegExp, 'this $1');
            //Figures outside headings (capital letter)
            myRegExp = new RegExp('(Figure)( |&nbsp;)+[0-9.]+', 'g');
            result = result.replace(myRegExp, 'This figure');

            //Listings in headings
            myRegExp = new RegExp('(<h[0-9]*.*?)(listing) [0-9.]*( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '$1');
            //Listings outside headings
            myRegExp = new RegExp('(listing)( |&nbsp;)*[0-9.]+', 'g');
            result = result.replace(myRegExp, 'this $1');
            //Listings outside headings (capital letter)
            myRegExp = new RegExp('(Listing)( |&nbsp;)+[0-9.]+', 'g');
            result = result.replace(myRegExp, 'This listing');

            //Tables in headings
            myRegExp = new RegExp('(<h[0-9]*.*?)(table)( |&nbsp;)+[0-9.]*( |&nbsp;)+', 'gi');
            result = result.replace(myRegExp, '$1');
            //Tables outside headings
            myRegExp = new RegExp('(table)( |&nbsp;)+[0-9.]+', 'g');
            result = result.replace(myRegExp, 'this $1');
            //Tables outside headings (capital letter)
            myRegExp = new RegExp('(Table)( |&nbsp;)+[0-9.]+', 'g');
            result = result.replace(myRegExp, 'This table');

            //Part
            myRegExp = new RegExp('(<a.*>)(part [0-9]+)(</a>)', 'g');
            result = result.replace(myRegExp, '$1this part$3');
            myRegExp = new RegExp('(<a.*>)(Part [0-9]+)(</a>)', 'g');
            result = result.replace(myRegExp, '$1This part$3');

            //Chapter
            myRegExp = new RegExp('(<a.*>)(chapter [0-9]+)(</a>)', 'g');
            result = result.replace(myRegExp, '$1this chapter$3');
            myRegExp = new RegExp('(<a.*>)(Chapter [0-9]+)(</a>)', 'g');
            result = result.replace(myRegExp, '$1This chapter$3');

            //Chapter
            myRegExp = new RegExp('(<a.*>)(appendix [0-9A-Z]*)(</a>)', 'g');
            result = result.replace(myRegExp, '$1this appendix$3');
            myRegExp = new RegExp('(<a.*>)(Chapter [0-9A-Z]*)(</a>)', 'g');
            result = result.replace(myRegExp, '$1This appendix$3');
        }

        return result;
    }
}

export const LivebookViewerHelper = new LivebookViewerHelperClass();